/**
 * @generated SignedSource<<a9f2d22fb7e43298c086194e9bb589e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CoachClientGenericQuery$variables = {
  username: string;
};
export type CoachClientGenericQuery$data = {
  readonly client: {
    readonly displayName: string | null | undefined;
    readonly email: string | null | undefined;
    readonly id: string;
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"ClientDetails_client">;
  } | null | undefined;
  readonly tags: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly title: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type CoachClientGenericQuery = {
  response: CoachClientGenericQuery$data;
  variables: CoachClientGenericQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "TagConnection",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "raw",
    "value": true
  }
],
v9 = {
  "kind": "Literal",
  "name": "utc",
  "value": true
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "measurement",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v14 = {
  "kind": "Literal",
  "name": "format",
  "value": "MMM DD, YYYY"
},
v15 = {
  "kind": "Literal",
  "name": "componentType",
  "value": "LESSON"
},
v16 = {
  "kind": "Literal",
  "name": "endWeek",
  "value": 0
},
v17 = {
  "kind": "Literal",
  "name": "startWeek",
  "value": -5
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Completion",
    "kind": "LinkedField",
    "name": "completion",
    "plural": false,
    "selections": [
      (v18/*: any*/)
    ],
    "storageKey": null
  }
],
v20 = {
  "kind": "Literal",
  "name": "componentType",
  "value": "HABIT"
},
v21 = {
  "kind": "Literal",
  "name": "period",
  "value": "LAST_7_DAYS"
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v24 = [
  (v18/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "total",
    "storageKey": null
  },
  (v23/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "trackingType",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetType",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentType",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carbsGrams",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proteinGrams",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fatGrams",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calories",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": (v8/*: any*/),
  "kind": "ScalarField",
  "name": "date",
  "storageKey": "date(raw:true)"
},
v33 = [
  (v14/*: any*/)
],
v34 = {
  "alias": null,
  "args": (v33/*: any*/),
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": "updatedAt(format:\"MMM DD, YYYY\")"
},
v35 = [
  (v1/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentCalories",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentFat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentCarbs",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentProtein",
    "storageKey": null
  },
  (v32/*: any*/)
],
v36 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 9999
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v38 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM D, YYYY"
  }
],
v39 = {
  "kind": "Literal",
  "name": "metricType",
  "value": "CHECKIN_ANSWER_MEASUREMENT"
},
v40 = {
  "alias": null,
  "args": (v8/*: any*/),
  "kind": "ScalarField",
  "name": "activityDate",
  "storageKey": "activityDate(raw:true)"
},
v41 = [
  (v1/*: any*/),
  (v40/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "value",
    "plural": false,
    "selections": [
      (v37/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v10/*: any*/)
        ],
        "type": "CheckinAnswerMeasurementValue",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v42 = {
  "alias": null,
  "args": (v33/*: any*/),
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": "createdAt(format:\"MMM DD, YYYY\")"
},
v43 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "value",
    "plural": false,
    "selections": [
      (v37/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v11/*: any*/),
          (v10/*: any*/)
        ],
        "type": "CheckinAnswerMeasurementValue",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  (v1/*: any*/),
  (v40/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachClientGenericQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": "client",
        "args": (v4/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ClientDetails_client"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoachClientGenericQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": "client",
        "args": (v4/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Enrollment",
            "kind": "LinkedField",
            "name": "enrollments",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "active",
                "storageKey": null
              },
              {
                "alias": "endDateRaw",
                "args": (v8/*: any*/),
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": "endDate(raw:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgressPhotoWeight",
                "kind": "LinkedField",
                "name": "progressPhotos",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urls",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "format",
                        "value": "MMMM D, YYYY"
                      },
                      (v9/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": "date(format:\"MMMM D, YYYY\",utc:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CheckinAnswerMeasurementValue",
                    "kind": "LinkedField",
                    "name": "weight",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Program",
                "kind": "LinkedField",
                "name": "program",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageURL",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v14/*: any*/),
                  (v9/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": "endDate(format:\"MMM DD, YYYY\",utc:true)"
              },
              {
                "alias": "lessonsByWeeks",
                "args": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "concreteType": "CompletionByWeek",
                "kind": "LinkedField",
                "name": "completionByWeeks",
                "plural": true,
                "selections": (v19/*: any*/),
                "storageKey": "completionByWeeks(componentType:\"LESSON\",endWeek:0,startWeek:-5)"
              },
              {
                "alias": "habitsByWeeks",
                "args": [
                  (v20/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "concreteType": "CompletionByWeek",
                "kind": "LinkedField",
                "name": "completionByWeeks",
                "plural": true,
                "selections": (v19/*: any*/),
                "storageKey": "completionByWeeks(componentType:\"HABIT\",endWeek:0,startWeek:-5)"
              },
              {
                "alias": "checkinsByWeeks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "componentType",
                    "value": "CHECKIN"
                  },
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "concreteType": "CompletionByWeek",
                "kind": "LinkedField",
                "name": "completionByWeeks",
                "plural": true,
                "selections": (v19/*: any*/),
                "storageKey": "completionByWeeks(componentType:\"CHECKIN\",endWeek:0,startWeek:-5)"
              },
              {
                "alias": "completion7Days",
                "args": (v22/*: any*/),
                "concreteType": "Completion",
                "kind": "LinkedField",
                "name": "completion",
                "plural": false,
                "selections": [
                  (v23/*: any*/)
                ],
                "storageKey": "completion(period:\"LAST_7_DAYS\")"
              },
              {
                "alias": "lessons7Days",
                "args": [
                  (v15/*: any*/),
                  (v21/*: any*/)
                ],
                "concreteType": "Completion",
                "kind": "LinkedField",
                "name": "completion",
                "plural": false,
                "selections": (v24/*: any*/),
                "storageKey": "completion(componentType:\"LESSON\",period:\"LAST_7_DAYS\")"
              },
              {
                "alias": "habits7Days",
                "args": [
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "concreteType": "Completion",
                "kind": "LinkedField",
                "name": "completion",
                "plural": false,
                "selections": (v24/*: any*/),
                "storageKey": "completion(componentType:\"HABIT\",period:\"LAST_7_DAYS\")"
              },
              {
                "alias": "completionByDate7Days",
                "args": (v22/*: any*/),
                "concreteType": "CompletionByDate",
                "kind": "LinkedField",
                "name": "completionByDate",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Completion",
                    "kind": "LinkedField",
                    "name": "completion",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "completionByDate(period:\"LAST_7_DAYS\")"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientNutritionTarget",
            "kind": "LinkedField",
            "name": "nutritionTarget",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientNutritionTarget",
            "kind": "LinkedField",
            "name": "nutritionMacroTarget",
            "plural": true,
            "selections": (v35/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientNutritionTarget",
            "kind": "LinkedField",
            "name": "nutritionPortionTarget",
            "plural": true,
            "selections": (v35/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v36/*: any*/),
            "concreteType": "ClientGoalConnection",
            "kind": "LinkedField",
            "name": "goals",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      (v1/*: any*/),
                      (v34/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "targetValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      {
                        "alias": "formattedDate",
                        "args": (v38/*: any*/),
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": "date(format:\"MMM D, YYYY\")"
                      },
                      (v18/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "goals(first:9999)"
          },
          {
            "alias": null,
            "args": (v36/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "ClientDetails_goals",
            "kind": "LinkedHandle",
            "name": "goals"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "photoURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "age",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gender",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "height",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "units",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "format",
                "value": "fromNow"
              }
            ],
            "kind": "ScalarField",
            "name": "lastLoginAt",
            "storageKey": "lastLoginAt(format:\"fromNow\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "birthday",
            "storageKey": null
          },
          {
            "alias": "rawDisplayName",
            "args": (v8/*: any*/),
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": "displayName(raw:true)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tag",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationsSetting",
            "kind": "LinkedField",
            "name": "notificationsSetting",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newMessageEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newResponseEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weeklyUpdate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dailyUpdate",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "bodyWeight",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "BODYWEIGHT"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v41/*: any*/),
            "storageKey": "metrics(measurementType:\"BODYWEIGHT\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "steps",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "STEP_COUNT"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v41/*: any*/),
            "storageKey": "metrics(measurementType:\"STEP_COUNT\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "photos",
            "args": [
              {
                "kind": "Literal",
                "name": "metricType",
                "value": "CHECKIN_ANSWER_PROGRESS_PHOTO"
              }
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v42/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "front",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "back",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "side",
                        "storageKey": null
                      }
                    ],
                    "type": "CheckinAnswerProgressPhotoValue",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "metrics(metricType:\"CHECKIN_ANSWER_PROGRESS_PHOTO\")"
          },
          {
            "alias": "allMetrics",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": [
              (v42/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": "metrics(limit:1,metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "bodyFat",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "BODYFAT"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v43/*: any*/),
            "storageKey": "metrics(measurementType:\"BODYFAT\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "chest",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "CHEST"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v43/*: any*/),
            "storageKey": "metrics(measurementType:\"CHEST\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "waist",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "WAIST"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v43/*: any*/),
            "storageKey": "metrics(measurementType:\"WAIST\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "hip",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "HIP"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v43/*: any*/),
            "storageKey": "metrics(measurementType:\"HIP\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "thigh",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "THIGH"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v43/*: any*/),
            "storageKey": "metrics(measurementType:\"THIGH\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "upperArm",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "UPPER_ARM"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v43/*: any*/),
            "storageKey": "metrics(measurementType:\"UPPER_ARM\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "calf",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "CALF"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v43/*: any*/),
            "storageKey": "metrics(measurementType:\"CALF\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": "shoulder",
            "args": [
              {
                "kind": "Literal",
                "name": "measurementType",
                "value": "SHOULDER"
              },
              (v39/*: any*/)
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": (v43/*: any*/),
            "storageKey": "metrics(measurementType:\"SHOULDER\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 999
              }
            ],
            "concreteType": "ClientFormConnection",
            "kind": "LinkedField",
            "name": "clientForms",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientFormEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientForm",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "submittedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v38/*: any*/),
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": "createdAt(format:\"MMM D, YYYY\")"
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "clientForms(first:999)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d462668151134872ed55a4847e64044",
    "id": null,
    "metadata": {},
    "name": "CoachClientGenericQuery",
    "operationKind": "query",
    "text": "query CoachClientGenericQuery(\n  $username: String!\n) {\n  tags {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  client: user(username: $username) {\n    id\n    username\n    email\n    displayName\n    ...ClientDetails_client\n  }\n}\n\nfragment ClientBodyWeightCard_client on User {\n  units\n  bodyWeight: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: BODYWEIGHT) {\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n      }\n    }\n  }\n}\n\nfragment ClientDetails_client on User {\n  id\n  username\n  displayName\n  timeZone\n  enrollments {\n    id\n    active\n    endDateRaw: endDate(raw: true)\n    ...ProgressDialog_enrollments\n    ...ClientProgramProgressCard_enrollment\n  }\n  nutritionTarget {\n    ...ClientNutritionCard_nutritionTarget\n    id\n  }\n  nutritionMacroTarget {\n    id\n    trackingType\n    targetType\n    commentType\n    carbsGrams\n    proteinGrams\n    fatGrams\n    calories\n    currentCalories\n    currentFat\n    currentCarbs\n    currentProtein\n    date(raw: true)\n  }\n  nutritionPortionTarget {\n    id\n    trackingType\n    targetType\n    commentType\n    carbsGrams\n    proteinGrams\n    fatGrams\n    calories\n    currentCalories\n    currentFat\n    currentCarbs\n    currentProtein\n    date(raw: true)\n  }\n  goals(first: 9999) {\n    edges {\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    ...ClientGoalsCard_goals\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ClientSummary_client\n  ...ClientSettingsDialog_client\n  ...ClientBodyWeightCard_client\n  ...ClientStepsCard_client\n  ...ClientProgressPhotosCard_client\n  ...ClientMeasurementsCard_client\n  ...ClientFormsCard_client\n}\n\nfragment ClientFormCardItem_clientForm on ClientForm {\n  slug\n  name\n  submittedAt\n  createdAt(format: \"MMM D, YYYY\")\n}\n\nfragment ClientFormsCard_client on User {\n  clientForms(first: 999) {\n    edges {\n      node {\n        ...ClientFormCardItem_clientForm\n        id\n      }\n    }\n  }\n}\n\nfragment ClientGoal_goal on ClientGoal {\n  id\n  name\n  targetValue\n  currentValue\n  formattedDate: date(format: \"MMM D, YYYY\")\n  completed\n}\n\nfragment ClientGoalsCard_goals on ClientGoalConnection {\n  totalCount\n  edges {\n    node {\n      id\n      updatedAt(format: \"MMM DD, YYYY\")\n      ...ClientGoal_goal\n    }\n  }\n  ...ClientGoalsDrawer_goals\n}\n\nfragment ClientGoalsDrawer_goals on ClientGoalConnection {\n  totalCount\n  edges {\n    node {\n      id\n      name\n      targetValue\n      currentValue\n      date(raw: true)\n      formattedDate: date(format: \"MMM D, YYYY\")\n    }\n  }\n  ...ClientGoalsList_goals\n}\n\nfragment ClientGoalsList_goals on ClientGoalConnection {\n  edges {\n    node {\n      id\n      name\n      targetValue\n      currentValue\n      date(raw: true)\n      formattedDate: date(format: \"MMM D, YYYY\")\n    }\n  }\n}\n\nfragment ClientLast7DaysCompletion_completionByDate on CompletionByDate {\n  date\n  completion {\n    completed\n    total\n    rate\n  }\n}\n\nfragment ClientLast7Days_enrollment on Enrollment {\n  completion7Days: completion(period: LAST_7_DAYS) {\n    rate\n  }\n  lessons7Days: completion(period: LAST_7_DAYS, componentType: LESSON) {\n    completed\n    total\n    rate\n  }\n  habits7Days: completion(period: LAST_7_DAYS, componentType: HABIT) {\n    completed\n    total\n    rate\n  }\n  completionByDate7Days: completionByDate(period: LAST_7_DAYS) {\n    ...ClientLast7DaysCompletion_completionByDate\n  }\n}\n\nfragment ClientMeasurementItem_metrics on ClientMetric {\n  value {\n    __typename\n    ... on CheckinAnswerMeasurementValue {\n      unit\n      measurement\n    }\n  }\n}\n\nfragment ClientMeasurementsCard_client on User {\n  units\n  allMetrics: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, limit: 1) {\n    createdAt(format: \"MMM DD, YYYY\")\n    id\n  }\n  bodyFat: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: BODYFAT) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  chest: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: CHEST) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  waist: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: WAIST) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  hip: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: HIP) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  thigh: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: THIGH) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  upperArm: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: UPPER_ARM) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  calf: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: CALF) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  shoulder: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: SHOULDER) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n}\n\nfragment ClientNutritionCard_nutritionTarget on ClientNutritionTarget {\n  id\n  trackingType\n  targetType\n  commentType\n  carbsGrams\n  proteinGrams\n  fatGrams\n  calories\n  date(raw: true)\n  updatedAt(format: \"MMM DD, YYYY\")\n}\n\nfragment ClientProgramActivity_enrollment on Enrollment {\n  lessonsByWeeks: completionByWeeks(componentType: LESSON, startWeek: -5, endWeek: 0) {\n    startDate\n    completion {\n      completed\n    }\n  }\n  habitsByWeeks: completionByWeeks(componentType: HABIT, startWeek: -5, endWeek: 0) {\n    startDate\n    completion {\n      completed\n    }\n  }\n  checkinsByWeeks: completionByWeeks(componentType: CHECKIN, startWeek: -5, endWeek: 0) {\n    startDate\n    completion {\n      completed\n    }\n  }\n}\n\nfragment ClientProgramProgressCard_enrollment on Enrollment {\n  program {\n    name\n    imageURL\n    slug\n    id\n  }\n  currentDay\n  totalDays\n  endDate(utc: true, format: \"MMM DD, YYYY\")\n  ...ClientProgramActivity_enrollment\n  ...ClientLast7Days_enrollment\n}\n\nfragment ClientProgressPhotosCard_client on User {\n  id\n  username\n  photos: metrics(metricType: CHECKIN_ANSWER_PROGRESS_PHOTO) {\n    id\n    createdAt(format: \"MMM DD, YYYY\")\n    value {\n      __typename\n      ... on CheckinAnswerProgressPhotoValue {\n        front\n        back\n        side\n      }\n    }\n  }\n}\n\nfragment ClientSettingsDialog_client on User {\n  ...ClientSettingsForm_settings\n  id\n  rawDisplayName: displayName(raw: true)\n  username\n  tag {\n    title\n    id\n  }\n  notificationsSetting {\n    ...ClientSettingsDialog_notificationsSetting\n    newMessageEmail\n    newResponseEmail\n    weeklyUpdate\n    dailyUpdate\n    id\n  }\n}\n\nfragment ClientSettingsDialog_notificationsSetting on NotificationsSetting {\n  newMessageEmail\n  newResponseEmail\n  weeklyUpdate\n  dailyUpdate\n}\n\nfragment ClientSettingsForm_settings on User {\n  email\n  photoURL\n  gender\n  location\n  birthday\n  units\n  height\n  weight\n  rawDisplayName: displayName(raw: true)\n  username\n  timeZone\n}\n\nfragment ClientStepsCard_client on User {\n  units\n  steps: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: STEP_COUNT) {\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n      }\n    }\n  }\n}\n\nfragment ClientSummary_client on User {\n  id\n  displayName\n  email\n  photoURL\n  age\n  gender\n  weight\n  height\n  units\n  location\n  clientStatus\n  lastLoginAt(format: \"fromNow\")\n}\n\nfragment ProgressDialog_enrollments on Enrollment {\n  progressPhotos {\n    url\n    urls\n    date(utc: true, format: \"MMMM D, YYYY\")\n    weight {\n      measurement\n      unit\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7fc460fe5eee3da27926f16463dd52c";

export default node;
